import type { TFileResponse } from '@shared/types';
import type { TAxiosResponseInterceptorSuccess } from '../types';

export const responderInterceptor: TAxiosResponseInterceptorSuccess =
  response => {
    if (response.config.responseType === 'blob') {
      const filename = response.headers['content-disposition']
        .split('=')[1]
        .split(';')[0]
        .replaceAll('"', '');
      return { data: response.data, filename } as TFileResponse;
    }

    try {
      const responseObject = response.data;
      let data = {};
      if (responseObject.pagination) {
        data = { pagination: responseObject.pagination };
      }
      if (responseObject.cursor) {
        data = { cursor: responseObject.cursor };
      }
      if (responseObject.meta) {
        data = { ...data, meta: responseObject.meta };
      }
      if (Object.keys(data).length) {
        return { data: responseObject.data, ...data };
      }
      return responseObject.data;
    } catch {
      return response;
    }
  };
